/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Popover } from 'devextreme-react/popover';
import './style.scss';

export default function Popovers() {
  const [defaultVisible, setDefaultVisible] = React.useState(false);
  const [withTitleVisible, setWithTitleVisible] = React.useState(false);
  const [withAnimationOptionsVisible, setWithAnimationOptionsVisible] = React.useState(false);
  const [withShadingOptionsVisible, setWithShadingOptionsVisible] = React.useState(false);

  const animationConfig = {
    show: {
      type: 'pop',
      from: {
        scale: 0,
      },
      to: {
        scale: 1,
      },
    },
    hide: {
      type: 'fade',
      from: 1,
      to: 0,
    },
  };

  const toggleDefault = () => {
    setDefaultVisible(!defaultVisible);
  }
  const toggleWithTitle = () => {
    setWithTitleVisible(!withTitleVisible);
  }
  const toggleWithAnimationOptions = () => {
    setWithAnimationOptionsVisible(!withAnimationOptionsVisible);
  }
  const showWithShadingOptions = () => {
    setWithShadingOptionsVisible(true);
  }
  const hideWithShadingOptions = () => {
    setWithShadingOptionsVisible(false);
  }

  return (
    <React.Fragment>
      <div className="form-readonly ma-2">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Default</div>
            <div className="form-value">
              <p>
                <span id="subject1">Popover Default </span>
                (<a
                  id="link1"
                  className="link"
                  onMouseEnter={toggleDefault}
                  onMouseLeave={toggleDefault}
                >details</a>)
              </p>
              <Popover
                target="#link1"
                position="top"
                width={300}
                visible={defaultVisible}
              >
                Make final decision on whether we are going to increase our Google AdWord spend based on our 2013 marketing plan.
              </Popover>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">With title</div>
            <div className="form-value">
              <p>
                <span id="subject2">Popover with title </span>
                              (<a
                  id="link2"
                  className="link"
                  onMouseEnter={toggleWithTitle}
                  onMouseLeave={toggleWithTitle}
                >details</a>)
              </p>

              <Popover
                target="#link2"
                position="top"
                width={300}
                showTitle={true}
                title="Details:"
                visible={withTitleVisible}
              >
                The designs for new brochures and
                website have been approved.
                Launch date is set for Feb 28.
              </Popover>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">With animation</div>
            <div className="form-value">
              <p>
                <span id="subject2">Popover with animation </span>
                              (<a
                  id="link3"
                  className="link"
                  onMouseEnter={toggleWithAnimationOptions}
                  onMouseLeave={toggleWithAnimationOptions}
                >details</a>)
              </p>

              <Popover
                target="#link3"
                position="top"
                width={300}
                visible={withAnimationOptionsVisible}
                animation={animationConfig}
              >
                2012 Sales Report has to be completed
                so we can determine if major changes
                are required to sales strategy.
              </Popover>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">With overlay</div>
            <div className="form-value">
              <p>
                <span id="subject4">Popover with overlay </span>
                  (<a
                  id="link4"
                  className="link"
                  onClick={showWithShadingOptions}
                >more</a>)
              </p>

              <Popover
                target="#link4"
                position="top"
                width={300}
                visible={withShadingOptionsVisible}
                onHiding={hideWithShadingOptions}
                shading={true}
                shadingColor="rgba(0, 0, 0, 0.5)"
              >
                The changes in our brochure designs for 2013 require
                us to update key areas of our website.
              </Popover>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
)}
